import { render } from "./editWaterFootprintConfigurationModal.vue?vue&type=template&id=15dc1b29&scoped=true&ts=true"
import script from "./editWaterFootprintConfigurationModal.vue?vue&type=script&lang=ts"
export * from "./editWaterFootprintConfigurationModal.vue?vue&type=script&lang=ts"

import "./editWaterFootprintConfigurationModal.vue?vue&type=style&index=0&id=15dc1b29&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15dc1b29"]])

export default __exports__